///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { Link } from "react-router-dom";

import messages from "../helpers/messages";

function InvalidRoute() {
  return (
    <div
      data-testid="invalid-route"
      className="flex justify-center items-center text-center app-level-error"
    >
      <div className="content">
        <p className="uppercase tiny-title">{messages.oops.defaultMessage}</p>
        <p className="title">{messages.pageNotFound.defaultMessage}</p>
        <p className="message">{messages.invalidRouteMessage.defaultMessage}</p>
        <br />
        <Link to="/">
          <button className="primary-button univers-67-bold-cond px-32">
            {messages.returnHome.defaultMessage}
          </button>
        </Link>
      </div>
    </div>
  );
}

export default InvalidRoute;
